import React from 'react';

export const DashboardTicketsDashboardSkeleton = () => (
    <div className="dashboard-skeleton mt-2">
        <div className="row g-3 mb-3">
            {[
                { key: 'tickets', title: 'Tickets', subtitle: 'Totales en el período', tone: 'bg-soft-primary' },
                { key: 'abiertos', title: 'Abiertos', subtitle: 'En cola de atención', tone: 'bg-soft-warning' },
                { key: 'resueltos', title: 'Resueltos', subtitle: 'Cerrados o resueltos', tone: 'bg-soft-success' },
                { key: 'vencidos', title: 'Vencidos', subtitle: 'Abiertos fuera de tiempo', tone: 'bg-soft-danger' },
                { key: 'sla', title: 'Fuera SLA', subtitle: 'Resueltos tarde', tone: 'bg-soft-danger' },
                { key: 'promedio', title: 'Prom. Resolución', subtitle: 'Tiempo promedio', tone: 'bg-soft-info' },
            ].map((item) => (
                <div className="col-12 col-md-6 col-xl-2" key={`dashboard-tickets-kpi-skeleton-${item.key}`}>
                    <div className={`card card-body border dashboard-kpi-card dashboard-kpi-card--compact ${item.tone}`}>
                        <div className="fs-12 text-muted text-uppercase">{item.title}</div>
                        <span className="ticket-skeleton-line d-block mt-2" style={{ width: '62px', height: '30px' }} />
                        <div className="text-muted fs-11 mt-1">{item.subtitle}</div>
                    </div>
                </div>
            ))}
        </div>

        <div className="row g-3 mb-3">
            {[
                'Variación tickets',
                'Variación abiertos',
                'Variación resueltos',
                'Variación fuera SLA',
            ].map((label) => (
                <div className="col-12 col-lg-3" key={`dashboard-tickets-variation-skeleton-${label}`}>
                    <div className="card card-body border dashboard-variation-card">
                        <div className="fs-12 text-muted text-uppercase mb-1">{label}</div>
                        <div className="d-flex align-items-end justify-content-between mt-2">
                            <span className="ticket-skeleton-line d-block" style={{ width: '56px', height: '24px' }} />
                            <span className="ticket-skeleton-line d-block" style={{ width: '52px', height: '16px' }} />
                        </div>
                        <div className="text-muted fs-11 mt-1">vs período anterior</div>
                    </div>
                </div>
            ))}
        </div>

        <div className="row g-3">
            {[
                { key: 'status', title: 'Tickets por estatus', colClass: 'col-12 col-xl-6' },
                { key: 'trend', title: 'Tendencia creados vs resueltos', colClass: 'col-12 col-xl-6' },
                { key: 'priority', title: 'Tickets por prioridad', colClass: 'col-12 col-xl-4' },
                { key: 'type', title: 'Tickets por tipo', colClass: 'col-12 col-xl-4' },
                { key: 'source', title: 'Tickets por origen', colClass: 'col-12 col-xl-4' },
                { key: 'aging', title: 'Antigüedad de tickets abiertos', colClass: 'col-12 col-xl-6' },
                { key: 'assignees', title: 'Top responsables por tickets', colClass: 'col-12 col-xl-6' },
            ].map((item) => (
                <div className={item.colClass} key={`dashboard-tickets-grid-skeleton-${item.key}`}>
                    <div className="card card-body border h-100">
                        <h6 className="mb-3">{item.title}</h6>

                        {item.key === 'trend' ? (
                            <>
                                <span className="ticket-skeleton-line d-block" style={{ width: '100%', height: '180px', borderRadius: '12px' }} />
                                <div className="d-flex align-items-center gap-3 fs-11 text-muted mt-2">
                                    <span className="d-inline-flex align-items-center gap-1"><i className="feather-minus text-primary" /> Creados</span>
                                    <span className="d-inline-flex align-items-center gap-1"><i className="feather-minus text-success" /> Resueltos</span>
                                </div>
                            </>
                        ) : item.key === 'assignees' ? (
                            <div className="table-responsive">
                                <table className="table table-sm align-middle mb-0">
                                    <thead>
                                        <tr>
                                            <th>Responsable</th>
                                            <th className="text-end">Tickets</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: 4 }).map((_, row) => (
                                            <tr key={`dashboard-tickets-assignee-line-${row}`}>
                                                <td><span className="ticket-skeleton-line d-block" style={{ width: '80%', height: '14px' }} /></td>
                                                <td className="text-end"><span className="ticket-skeleton-line d-inline-block" style={{ width: '34px', height: '14px' }} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            Array.from({ length: 5 }).map((__, row) => (
                                <div className="mb-2" key={`dashboard-tickets-grid-line-${item.key}-${row}`}>
                                    <div className="d-flex justify-content-between fs-12 mb-1">
                                        <span className="ticket-skeleton-line d-inline-block" style={{ width: '34%', height: '10px' }} />
                                        <span className="ticket-skeleton-line d-inline-block" style={{ width: '18%', height: '10px' }} />
                                    </div>
                                    <span className="ticket-skeleton-line d-block" style={{ width: '100%', height: '8px' }} />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            ))}
        </div>
    </div>
);
